/*
 * DISTRIBUTION STATEMENT C. Distribution authorized to U.S. Government Agencies and their contractors; Critical
 * Technology; 19 October 2017. Other requests for this document shall be referred to Chemical and Biological
 * Technologies, Defense Threat Reduction Agency, 8725 John J Kingman Road, Fort Belvoir, VA 22060-6201.
 *
 * WARNING: This document contains technical data whose export is restricted by the Arms Export Control Act (Sec 2751
 * of Title 22, United States Code) or the Export Control Reform Act of 2018 (Chapter 58 Sections 4801-4852 of Title
 * 50, United States Code). Violations of these export laws are subject to severe criminal penalties. Disseminate in
 * accordance with provisions of DoD Directive 5230.25 and DoD Instruction 2040.02. DESTRUCTION NOTICE: For
 * unclassified, limited distribution documents, destroy by any method that will prevent disclosure of the contents
 * or reconstruction of the document.
 *
 * This material is based upon work supported by the Under Secretary of War for Research and Engineering under Air
 * Force Contract No. FA8702-15-D-0001 or FA8702-25-D-B002. Any opinions, findings, conclusions or recommendations
 * expressed in this material are those of the author(s) and do not necessarily reflect the views of the Under
 * Secretary of War for Research and Engineering.
 *
 * © 2026 Massachusetts Institute of Technology.
 *
 * The software/firmware is provided to you on an As-Is basis
 *
 * Delivered to the U.S. Government with Unlimited Rights, as defined in DFARS Part 252.227-7013 or 7014 (Feb 2014).
 * Notwithstanding any copyright notice, U.S. Government rights in this work are defined by DFARS 252.227-7013 or
 * DFARS 252.227-7014 as detailed above. Use of this work other than as specifically authorized by the U.S.
 * Government may violate any copyrights that exist in this work.
 *
 * This document contains Controlled Unclassified Information (CUI). Handling of this information is subject to the
 * controls identified in DFARS 252.204-7012 - SAFEGUARDING COVERED DEFENSE INFORMATION AND CYBER INCIDENT REPORTING.
 */

// Action types
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_LOADING = 'SET_USER_LOADING';
export const SET_BUILD_INFO = 'SET_BUILD_INFO';
export const SET_DAL_OPTIONS = 'SET_DAL_OPTIONS';
export const SET_STUDY_STATUS_OPTIONS = 'SET_STUDY_STATUS_OPTIONS';
export const SET_ORGANISM_OPTIONS = 'SET_ORGANISM_OPTIONS';
export const SET_ORGANIZATIONS_OPTIONS = 'SET_ORGANIZATIONS_OPTIONS';
export const SET_SPONSORS_OPTIONS = 'SET_SPONSORS_OPTIONS';
export const SET_DATA_TYPE_OPTIONS = 'SET_DATA_TYPE_OPTIONS';
export const SET_EXPOSURE_TYPE_OPTIONS = 'SET_EXPOSURE_TYPE_OPTIONS';
export const SET_TRUTH_DATA_OPTIONS = 'SET_TRUTH_DATA_OPTIONS';
export const SET_STUDY_SEARCH_QUERY = 'SET_STUDY_SEARCH_QUERY';
export const SET_STUDY_SEARCH_RESULTS = 'SET_STUDY_SEARCH_RESULTS';
export const SET_TAGS = 'SET_TAGS';
export const SET_SUPPORT_FLAGS = 'SET_SUPPORT_FLAGS';
export const SET_MODEL_TYPES_OPTIONS = 'SET_MODEL_TYPES_OPTIONS';
export const SET_MODEL_EXPOSURE_TYPES_OPTIONS = 'SET_MODEL_EXPOSURE_TYPES_OPTIONS';
export const SET_PAGE_INFO = 'SET_PAGE_INFO';
export const SET_TOOLS_PAGE = 'SET_TOOLS_PAGE';
export const SET_FEATURE_COHORT = 'SET_FEATURE_COHORT';
export const SET_FEATURE_STUDYCARD = 'SET_FEATURE_STUDYCARD';
export const SET_FEATURE_ANALYST_WORKBENCH = 'SET_FEATURE_ANALYST_WORKBENCH';
export const SET_PAGE_LOADING = 'SET_PAGE_LOADING';
export const SET_THEME = 'SET_THEME';
export const SET_KUBEFLOW_PROVISIONING = 'SET_KUBEFLOW_PROVISIONING';

export function setUserInfo(userInfo) {
  return { type: SET_USER_INFO, userInfo};
}

export function setUserLoading(userLoading) {
  return { type: SET_USER_LOADING, userLoading};
}

export function setBuildInfo(buildInfo) {
  return { type: SET_BUILD_INFO, buildInfo};
}

export function setDataAccessLevelOptions(options) {
  return { type: SET_DAL_OPTIONS, options};
}

export function setStudyStatusOptions(options) {
  return { type: SET_STUDY_STATUS_OPTIONS, options};
}

export function setOrganismOptions(options) {
  return { type: SET_ORGANISM_OPTIONS, options};
}

export function setOrganizationsOptions(options) {
  return { type: SET_ORGANIZATIONS_OPTIONS, options};
}

export function setSponsorsOptions(options) {
  return { type: SET_SPONSORS_OPTIONS, options};
}

export function setDataTypeOptions(options) {
  return { type: SET_DATA_TYPE_OPTIONS, options};
}

export function setExposureTypeOptions(options) {
  return { type: SET_EXPOSURE_TYPE_OPTIONS, options};
}

export function setTruthDataOptions(options) {
  return { type: SET_TRUTH_DATA_OPTIONS, options};
}

export function setStudySearchQuery(query) {
  return { type: SET_STUDY_SEARCH_QUERY, query};
}

export function setStudySearchResults(results) {
  return { type: SET_STUDY_SEARCH_RESULTS, results};
}

export function setTags(tags) {
  return { type: SET_TAGS, tags};
}

export function setSupportFlags(supportFlags) {
  return { type: SET_SUPPORT_FLAGS, supportFlags}
}

export function setModelTypesOptions(options) {
  return { type: SET_MODEL_TYPES_OPTIONS, options};
}

export function setModelExposureTypesOptions(options) {
  return { type: SET_MODEL_EXPOSURE_TYPES_OPTIONS, options};
}

export function setPageInfo(pages) {
  return { type: SET_PAGE_INFO, pages}
}

export function setPageTools(toolsPage) {
  return { type: SET_TOOLS_PAGE, toolsPage}
}

export function setFeatureCohort(feature_cohort) {
  return { type: SET_FEATURE_COHORT, feature_cohort}
}

export function setFeatureStudyCard(feature_studycard) {
  return { type: SET_FEATURE_STUDYCARD, feature_studycard}
}

export function setFeatureAnalystWorkbench(feature_aw) {
  return { type: SET_FEATURE_ANALYST_WORKBENCH, feature_aw}
}

export function setPageLoading(pageLoading) {
  return { type: SET_PAGE_LOADING, pageLoading};
}

export function setTheme(theme) {
  return { type: SET_THEME, theme};
}

export function setKubeflowProvisioning(kubeflowProvisioning) {
  return { type: SET_KUBEFLOW_PROVISIONING, kubeflowProvisioning};
}
